// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"dd87b702","743":"7d579273","917":"128cd148"}[chunkId] + ".chunk.js";
};